module.exports = __webpack_public_path__ + "static/media/29ADMSPC14.b4f8c85f.jpg";